import { cx } from '@/utils/strings'

export default function Icon({ icon, ...props }: { icon: string; [key: string]: any }) {
  const char = String.fromCharCode(parseInt(icon, 16))
  return (
    <span
      {...props}
      className={cx(
        'inline-flex items-center justify-center align-middle w-[1em] h-[1em]',
        'font-bwi not-italic font-normal leading-none antialiased normal-case',
        props.className
      )}
    >
      {char}
    </span>
  )
}
